import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ALL_ROUTES } from '@/utils/constants';
import { BaseBtn } from '@/components/buttons/base-btn/BaseBtn';

/**
 * NotFound - 404 Page Not Found
 *
 * Design:
 * - Centered layout with large 404 heading
 * - Consistent with Palazzo Mantica design system
 * - Primary and secondary navigation buttons
 * - Full viewport height for dramatic effect
 */
export const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background px-4 py-8 gap-8">
      {/* 404 Error Code */}
      <div className="text-center">
        <h1 className="text-heading-xl font-display font-bold text-primary leading-none mb-4">
          404
        </h1>
        <p className="text-heading-md font-display text-text-primary mb-2">
          {t('pages.notFound.title', 'Page Not Found')}
        </p>
        <p className="text-body text-text-primary opacity-70 max-w-xs mx-auto">
          {t('pages.notFound.subtitle', 'Sorry, the page you are looking for does not exist.')}
        </p>
      </div>

      {/* Navigation Buttons */}
      <div className="flex flex-col gap-3 w-full max-w-xs">
        <BaseBtn
          label={t('pages.notFound.backToHome', 'Back to Home')}
          onClick={() => navigate(ALL_ROUTES.basePath)}
        />
        <button
          onClick={() => navigate(-1)}
          className="px-6 py-3 text-label font-medium text-primary border-2 border-primary rounded-full transition-colors duration-200 hover:bg-primary hover:text-accent"
        >
          {t('pages.notFound.goBack', 'Go Back')}
        </button>
      </div>
    </div>
  );
};
